<template>
	<datepicker placeholder="Escolha uma data"></datepicker>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
    components: {
		'datepicker': Datepicker,
    }
}
</script>

<style>

	/*Overriding the plugins original CSS*/
	.vdp-datepicker__calendar .cell.selected {
		background: #63C0BB !important;
	}	

	.vdp-datepicker__calendar .cell:hover, .vdp-datepicker__calendar .cell.selected:hover {
		background: #63C0BB;
	}

	.vdp-datepicker__calendar header span {
		color: #63C0BB;
	}

	/*Stop Overriding the plugin original CSS*/

</style>
